import type { ComponentType } from "react";
import { GoogleBrandIcon } from "./GoogleBrandIcon";
import { MicrosoftBrandIcon } from "./MicrosoftBrandIcon";
import { OrangeBrandIcon } from "./OrangeBrandIcon";
import { SfrBrandIcon } from "./SfrBrandIcon";
import { FreeBrandIcon } from "./FreeBrandIcon";
import { IonosBrandIcon } from "./IonosBrandIcon";
import { OvhBrandIcon } from "./OvhBrandIcon";
import { LaposteBrandIcon } from "./LaposteBrandIcon";
import { YahooBrandIcon } from "./YahooBrandIcon";
import { ManualBrandIcon } from "./ManualBrandIcon";

type IconProps = { className?: string };

const MAP: Record<string, ComponentType<IconProps>> = {
  gmail: GoogleBrandIcon,
  microsoft: MicrosoftBrandIcon,
  orange: OrangeBrandIcon,
  sfr: SfrBrandIcon,
  free: FreeBrandIcon,
  ionos: IonosBrandIcon,
  ovh: OvhBrandIcon,
  laposte: LaposteBrandIcon,
  yahoo: YahooBrandIcon,
  manual: ManualBrandIcon,
};

type Props = {
  providerId: string;
  className?: string;
};

export function ProviderBrandIcon({ providerId, className }: Props) {
  const Icon = MAP[providerId];
  if (!Icon) {
    return (
      <span
        className={className}
        aria-hidden
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.65rem",
          fontWeight: 700,
          color: "var(--mail-muted)",
        }}
      >
        @
      </span>
    );
  }
  return <Icon className={className} />;
}
